import { Component, EventEmitter, Output } from '@angular/core';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ManageFavoritesComponent } from '../../../../manage-favorites/manage-favorites.component';
import { FavoriteStation } from 'src/app/modules/route-planner/interfaces/favorites/favorite-station.interface';
import { FavoriteStations } from 'src/app/modules/route-planner/interfaces/favorites/favorite-stations.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { DIDNT_ADD_FAVORITE_STATIONS, EDIT, FAVORITE_STATIONS, LAST_SEARCHES } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Direction } from '@angular/cdk/bidi';

@Component({
    selector: 'app-favorite-stations',
    templateUrl: './favorite-stations.component.html',
    styleUrls: ['./favorite-stations.component.scss'],
    standalone: false
})
export class FavoriteStationsComponent {
  @Output() onFavoriteStationClick = new EventEmitter<FavoriteStation>();

  favoriteStations: FavoriteStations;

  lastSearchesText: string
  favoriteStationText: string
  editText: string
  didntAddFavoriteStationsTextPart1: string
  didntAddFavoriteStationsTextPart2: string

  direction: Direction

  constructor(
    private readonly routePlanningService: RoutePlanningService,
    private readonly favoritesService: FavoritesService,
    private readonly languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.favoriteStations = this.favoritesService.favorites?.stations;

    this.favoritesService.onFavoritesChange$.subscribe((favorites) => {
      this.favoriteStations = favorites?.stations;
    });
    this.initializeMultiLanguageTexts()
  }

  openEditFavoritesMenu() {
    this.routePlanningService._componentOverlaySub.next({
      componentType: ManageFavoritesComponent,
      data: {
        closeCallbackFn: (reOpen: boolean) => {
          if(reOpen) {
            this.openEditFavoritesMenu();
          }
          else {
            this.favoriteStations = this.favoritesService.favorites.stations;
          }
        },
      },
    });
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.lastSearchesText = LAST_SEARCHES[language.language]
      this.favoriteStationText = FAVORITE_STATIONS[language.language]
      this.editText = EDIT[language.language]
      const text = DIDNT_ADD_FAVORITE_STATIONS[language.language];
      const words = text.split(' ');
      this.didntAddFavoriteStationsTextPart1 = words.slice(0, 3).join(' ');
      this.didntAddFavoriteStationsTextPart2 = words.slice(3).join(' ');
    })
  }
}
